import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import FontFaceObserver from 'fontfaceobserver'
import { refreshTurntable } from '../redux/turntable/actions'
import { isSafari } from 'react-device-detect'

export const useFontLoaded = page => {
  const dispatch = useDispatch()
  useEffect(() => {
    const teachersFont = new FontFaceObserver('Teachers', { weight: 400 })

    const arrayFonts = [teachersFont.load()]

    if (page === 'rcg' && !isSafari) {
      // safari twemoji flags not working
      const flagsFont = new FontFaceObserver('Twemoji Country Flags', {})
      arrayFonts.push(flagsFont.load('🇺🇸🇨🇦🇬🇧'))
    }

    Promise.all(arrayFonts)
      .then(function () {
        dispatch(refreshTurntable(page))
        const teachersSemiBoldFont = new FontFaceObserver('Teachers', {
          weight: 600,
        })
        teachersSemiBoldFont.load()
      })
      .catch(error => console.log(error))
  }, [])
}
